<template>
    <div class="d-flex">
        <div v-if="created_at" class="caption g4--text">
            {{ created_at | format_datetime }}
        </div>
        <div class="d-flex">
            <slot name="edit">
                <div
                    v-if="canEdit"
                    class="caption n3--text text-decoration-underline cursor-pointer mx-1"
                    @click="$emit('edit')"
                >
                    {{ $t("Edit") }}
                </div>
            </slot>
            <div
                v-if="canDelete"
                class="caption n3--text text-decoration-underline cursor-pointer"
                @click="$emit('delete')"
            >
                {{ $t("Delete") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TaskInfoListRowFooter",
    props: {
        created_at: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        canDelete: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return {

        }
    }
}
</script>

<style scoped>

</style>